import { useCallback, useState } from "react";
import { useAppDispatch } from "../../../store";
import { useOpenProgressModal } from "../../../lib/hooks/useOpenProgressModal";
import { DASHBOARD_RECALCULATED } from "../../../lib/constants";
import { DashboardService } from "../../../services/dashboard";
import { setErrorMessage } from "../../../acions/actionsCreators/messageActions";

export const useRecalculate = () => {
  const dispatch = useAppDispatch();

  const [isRecalculated, setIsRecalculated] = useState<boolean>(true);

  const [disabled, setDisabled] = useState<boolean>(false);

  const { openModal } = useOpenProgressModal(
    "Recalculating dashboard data",
    "Recalculating dashboard data failed",
    (id?: string) => setIsRecalculated((prev) => !prev),
    {
      customMsg: DASHBOARD_RECALCULATED,
      closable: false
    }
  );

  const recalculate = useCallback(async () => {
    setDisabled(true);
    try {
      const id: string = await DashboardService.calculate();
      openModal(id);
      setDisabled(false);
    } catch (error: any) {
      setDisabled(false);
      dispatch(setErrorMessage(error.response.data.title, true));
    }
  }, [dispatch, openModal]);

  return { isRecalculated, recalculate, disabled };
};
